import { EditNotificationsOutlined } from "@mui/icons-material"
import { Box, Button, Typography, useTheme } from "@mui/material"
import { DataGrid, GridDeleteIcon } from "@mui/x-data-grid"
import { useEffect, useState } from "react"
import ConfirmationDialog from "../../components/ConfirmationDialog"
import Header from "../../components/Header"
import ActionApi from "../../services/api/actions"
import { tokens } from "../../theme"
import ActionForm from "./form"

const Actions = () => {
	const theme = useTheme()
	const colors = tokens(theme.palette.mode)
	const actionModule = ActionApi()
	const [actionList, setActionList] = useState([])

	const [isConfirmationOpen, setConfirmationOpen] = useState(false)
	const [selectedId, setSelectedId] = useState("")
	const [editingData, setEditingData] = useState()

	const [open, setOpen] = useState(false)

	const columns = [
		{ field: "id", headerName: "ID" },
		{
			field: "name",
			headerName: "Name",
			flex: 1,
			cellClassName: "name-column--cell",
		},
		{
			field: "",
			headerName: "Edit",
			flex: 1,
			renderCell: ({ row: { id } }) => {
				return (
					<Box display="flex" justifyContent="center" borderRadius="4px">
						<Typography
							variant="button"
							color="warning"
							onClick={() => editAction(id)}
							style={{ cursor: "pointer", marginRight: "10px" }}
						>
							<EditNotificationsOutlined
								fontSize="small"
								style={{ marginRight: "4px" }}
							/>
							Edit
						</Typography>

						<Typography
							variant="button"
							color="error"
							onClick={() => deleteAction(id)}
							style={{ cursor: "pointer" }}
						>
							<GridDeleteIcon fontSize="small" style={{ marginRight: "4px" }} />
							Delete
						</Typography>
					</Box>
				)
			},
		},
	]

	useEffect(() => {
		fetchData()
	}, [])

	const fetchData = async () => {
		try {
			const data = await actionModule.getAll()

			setActionList(data.results)
		} catch (error) {
			console.log(fetchErrorMsg, error)
		}
	}

	const editAction = (id) => {
		const action = actionList.find((row) => row.id === id)
		setEditingData(action)
		viewForm()
	}

	const deleteAction = (id) => {
		setSelectedId(id)
		handleOpenConfirmation()
	}

	const handleOpenConfirmation = () => {
		setConfirmationOpen(true)
	}

	const handleCloseConfirmation = () => {
		setConfirmationOpen(false)
	}

	const handleConfirmAction = () => {
		try {
			const response = actionModule.destroy(selectedId)

			console.log(deletedSuccessMsg, response)
			fetchData()
		} catch (error) {
			console.log(deleteErrorMsg, error)
		}

		handleCloseConfirmation()
	}

	const createAction = () => {
		setEditingData()
		viewForm()
	}

	const viewForm = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
		fetchData()
	}

	return (
		<>
			<Box m="20px">
				<Header title="Actions" subtitle="" />

				<Box display="flex" justifyContent="end" m="0 0 0 0">
					<Button
						type="submit"
						color="secondary"
						variant="contained"
						onClick={createAction}
					>
						Create Action
					</Button>
				</Box>

				<Box
					m="40px 0 0 0"
					height="75vh"
					sx={{
						"& .MuiDataGrid-root": {
							border: "none",
						},
						"& .MuiDataGrid-cell": {
							borderBottom: "none",
						},
						"& .name-column--cell": {
							color: colors.greenAccent[300],
						},
						"& .MuiDataGrid-columnHeaders": {
							backgroundColor: colors.blueAccent[700],
							borderBottom: "none",
						},
						"& .MuiDataGrid-virtualScroller": {
							backgroundColor: colors.primary[400],
						},
						"& .MuiDataGrid-footerContainer": {
							borderTop: "none",
							backgroundColor: colors.blueAccent[700],
						},
						"& .MuiCheckbox-root": {
							color: `${colors.greenAccent[200]} !important`,
						},
					}}
				>
					<DataGrid rows={actionList} columns={columns} />
				</Box>
			</Box>

			<ConfirmationDialog
				open={isConfirmationOpen}
				onClose={handleCloseConfirmation}
				onConfirm={handleConfirmAction}
			/>

			<ActionForm
				formData={editingData}
				open={open}
				handleClose={() => handleClose()}
			/>
		</>
	)
}

const deletedSuccessMsg = "Action deleted successfully: "
const deleteErrorMsg = "Not deleted action. "
const fetchErrorMsg = "Not loading actions"

export default Actions
